import dla from "../../images/projets/batiment.JPG";


export const projects = [
    {
        id: 1,
        title: "Groupe DLA S.E.N.C.",
        description: "Site web pour le Groupe DLA S.E.N.C.",
        image: dla,
        services: ['Site Web'],
        url: "https://www.groupedla.com",
    },
];